import React from 'react';
import { ENV_DECLARONS, isBrandActive } from 'src/config/environment.config';
import { useLocation } from 'react-router-dom';
import useTailwindBrand from '../../Theme/useTailwindBrand';
import { useBrandAuthConfig } from '../../Hooks/Auth/useBrandAuthConfig';
import Layout from '../LayoutApp';
import IndexApp from '../IndexApp';
interface LayoutAuthProps {
  children: React.ReactNode;
  rightContent?: React.ReactNode;
  currentStep?: number;
  totalSteps?: number;
}

export const LayoutAuth: React.FC<LayoutAuthProps> = ({
  children,
  rightContent,
  currentStep,
  totalSteps,
}) => {
  const { classes } = useTailwindBrand();
  const { designConfig } = useBrandAuthConfig();
  const location = useLocation()

  return (
    <IndexApp
      index={5}
      theme={'dark'}
      isDeclarons={isBrandActive(ENV_DECLARONS)}
      teachr={undefined}
      className='backdrop-blur-xl '
      class={`${designConfig.globalCustom} bg-center bg-no-repeat bg-cover`}
      component={
        <Layout
          className={`${location.pathname.includes('/register') && designConfig.firstCustom} ${classes.fontFamily} bg-right-bottom bg-no-repeat bg-30% w-full`}
          className2="">
          <div className={`lg:flex items-center justify-center w-full gap-6 ${location.pathname.includes('/register') && 'mt-8 md:mt-10'}`}>
            {children}
            {rightContent}
          </div>
        </Layout>
      }
    />
  );
};
